import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Edit } from 'lucide-react';
import { useSurvey } from '@contexts/SurveyContext';
import { SurveyInfoTabs } from './SurveyInfoTabs';
import { StatusSelector } from './StatusSelector';
import { Button } from '@common/Button';
import { SurveyForm } from '../SurveyForm';

export const SurveyInfoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { activeSurvey } = useSurvey();
  const [showEditForm, setShowEditForm] = React.useState(false);

  // Redirect if no active survey
  if (!activeSurvey) {
    navigate('/roadscope');
    return null;
  }

  const handleEditClick = () => {
    setShowEditForm(true);
  };

  const handleEditClose = () => {
    setShowEditForm(false);
  };

  const handleEditSave = async (updatedData) => {
    try {
      // Handle survey update
      await updateSurvey(activeSurvey.id, updatedData);
      setShowEditForm(false);
      // Show success toast or feedback
    } catch (error) {
      // Handle error
      console.error('Failed to update survey:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#3D3F42]">
      {/* Header */}
      <div className="sticky top-0 bg-[#2A2B2E] shadow-sm z-10 p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-gray-700 rounded-lg"
            >
              <ArrowLeft className="w-6 h-6 text-white" />
            </button>
            <div>
              <h1 className="text-xl font-semibold text-white">{activeSurvey.name}</h1>
              <p className="text-sm text-gray-400">View and manage survey details</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <StatusSelector survey={activeSurvey} />
            <Button
              onClick={handleEditClick}
              className="bg-blue-500 hover:bg-blue-600 text-white flex items-center gap-2"
            >
              <Edit className="w-4 h-4" />
              Edit Survey
            </Button>
          </div>
        </div>
      </div>

      {/* Survey Info Content */}
      <SurveyInfoTabs survey={activeSurvey} />

      {/* Edit Survey Modal */}
      {showEditForm && (
        <SurveyForm
          survey={activeSurvey}
          isEdit={true}
          onClose={handleEditClose}
          onSave={handleEditSave}
        />
      )}
    </div>
  );
};